import { render, staticRenderFns } from "./identitySecInfo.vue?vue&type=template&id=3041b4d3&scoped=true&"
import script from "./identitySecInfo.vue?vue&type=script&lang=js&"
export * from "./identitySecInfo.vue?vue&type=script&lang=js&"
import style0 from "./identitySecInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./identitySecInfo.vue?vue&type=style&index=1&id=3041b4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041b4d3",
  null
  
)

export default component.exports